import type { CommandAction } from '../../../types/CommandAction.js';
import { checkResolvedVersions } from './checkResolvedVersions.js';
import { readYarnLock } from './readYarnLock.js';
import { processYarnLock } from './processYarnLock.js';

/** Executor for the "info lock-file" verb */
export const execute: CommandAction<never> = async (params) => {
  const { appPath: cwd } = params;

  try {
    // This returns either the lock file contents or an error message
    const lockResult = await readYarnLock(cwd);
    if (typeof lockResult === 'string') {
      return { message: lockResult, hasErrors: true };
    }

    const resolvedVersions = processYarnLock(lockResult);
    return {
      message: checkResolvedVersions(resolvedVersions),
    };
  } catch (err) {
    return {
      message: `Error getting info from lockfile: ${(err as Error).stack || err}`,
      hasErrors: true,
    };
  }
};
